module.exports = __webpack_public_path__ + "media/music_1.9b228666.mp3";